// Module
var code = "<div class=\"input-group\"> <input type=\"number\" class=\"form-control\" ng-model=\"vm.value\" id=\"field_{{vm.field.id}}\" placeholder=\"{{ vm.requiredPlaceholderText | lowercase }}\" ng-required=\"{{ vm.required ? 'true' : '' }}\"> </div> ";
// Exports
module.exports = code;